import fetchWithCache from "../../utils/ApiCaching";

const state = {
    helpTextData: {},
    loading: false,
    error: null
}

const mutations = {
    setHelpTextData(state, payload) {
        // Handle both direct data and nested success response
        const data = payload?.data || payload;
        state.helpTextData = data;
    },
    setLoading(state, payload) {
        state.loading = payload;
    },
    setError(state, payload) {
        state.error = payload;
    }
};

const actions = {
    async fetchHelpText({ commit }, { forceRefresh = false } = {}) {
        commit('setLoading', true);
        commit('setError', null);
        
        try {
            // Clear cache if force refresh is requested
            if (forceRefresh) {
                localStorage.removeItem('apiCache_helpTextData');
            }
            
            const data = await fetchWithCache(
                { commit },
                {
                    apicmd: 'getHelpText',
                    cacheKey: 'apiCache_helpTextData',
                    postData: {},
                    mutation: 'setHelpTextData',
                    cacheDuration: 7 * 24 * 60 * 60 * 1000, // 7 days
                    url: '/help-text/',
                    method: 'GET',
                    retryCount: 2
                }
            );
            
            return data;
        } catch (error) {
            console.error('Error fetching help text:', error);
            commit('setError', error.message || 'Failed to fetch help text');
            throw error;
        } finally {
            commit('setLoading', false);
        }
    },

    // Clear help text cache
    clearHelpTextCache() {
        localStorage.removeItem('apiCache_helpTextData');
        console.log('Help text cache cleared');
    },

    // Get specific help text by key
    getHelpTextByKey({ state }, key) {
        return state.helpTextData[key] || null;
    }
};

const getters = {
    stHelpTextData: state => state.helpTextData,
    stHelpTextLoading: state => state.loading,
    stHelpTextError: state => state.error,
    
    // Helper getter to retrieve specific help text by key
    getHelpTextByKey: (state) => (key) => {
        return state.helpTextData[key] || null;
    }
};

export default {
    state,
    mutations,
    actions,
    getters
}

